// 2026-05-23 multi-channel refactor: the bare /meta/callback no longer exists
// as a route, but kept here as defense-in-depth. The three new per-provider
// paths are added so the app refuses to redirect users to OAuth callback
// pages after sign-in (would leak / loop / break).
const RESERVED_ROUTES = [
  '/callback',
  '/cli/callback',
  '/meta/callback',
  '/meta/callback/whatsapp',
  '/meta/callback/instagram',
  '/meta/callback/instagram-fb',
  '/signup',
];

export function sanitizeReturnTo(value: string | null | undefined): string {
  if (value == null) return '/';
  const trimmed = value.trim();
  if (trimmed === '') return '/';
  if (trimmed.includes('\\')) return '/';
  if (!trimmed.startsWith('/')) return '/';
  if (trimmed.startsWith('//')) return '/';
  const pathOnly = trimmed.split(/[?#]/, 1)[0];
  if (RESERVED_ROUTES.includes(pathOnly)) return '/';
  return trimmed;
}
